import type { ReactNode } from "react";
import { Button, vars } from "@pack-it-up/ui-web";

// One archived resource row: name + meta, with Restore and Delete actions. Shared by
// My Trips and My Templates (Doc 10 §5).
export const ArchiveRow = ({
  name,
  meta,
  onOpen,
  onRestore,
  onDelete,
}: {
  name: string;
  meta?: string;
  onOpen?: () => void;
  onRestore: () => void;
  onDelete: () => void;
}): ReactNode => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: vars.space.md,
      border: `1px solid ${vars.color.border}`,
      borderRadius: vars.radius.lg,
      padding: `${vars.space.md} ${vars.space.lg}`,
      background: vars.color.surface,
    }}
  >
    <button
      type="button"
      onClick={onOpen}
      disabled={onOpen === undefined}
      style={{
        flex: 1,
        minWidth: 0,
        textAlign: "left",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: onOpen !== undefined ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        gap: vars.space.xxs,
      }}
    >
      <span
        style={{
          fontSize: vars.font.sizeSm,
          fontWeight: vars.font.weightMedium,
          color: vars.color.text,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {name}
      </span>
      {meta !== undefined && meta !== "" && (
        <span style={{ fontSize: vars.font.sizeXs, color: vars.color.textMuted }}>{meta}</span>
      )}
    </button>
    <Button variant="secondary" size="sm" onClick={onRestore}>
      Restore
    </Button>
    <Button variant="danger" size="sm" onClick={onDelete}>
      Delete
    </Button>
  </div>
);
